"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ObjectForm = _interopRequireDefault(require("@/components/ObjectForm"));
var _validate = require("@/libs/validate1.js");
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    formIcon: _ObjectForm.default
  },
  data: function data() {
    return {
      formData: {
        rules: {
          userName: [{
            required: true,
            message: "请输入专家姓名",
            trigger: "blur"
          }],
          IDCode: [
          // { required: true, message: "请输入身份证号", trigger: "blur" },
          {
            validator: _validate.validateIdNo,
            trigger: "blur"
          }],
          loginID: [{
            required: true,
            message: "请输入登录账号",
            trigger: "blur"
          }],
          tel: [{
            required: true,
            message: "请输入手机号",
            trigger: "blur"
          }, {
            validator: _validate.validatePhoneTwo,
            trigger: "blur"
          }],
          email: [{
            required: true,
            message: "请输入邮箱地址",
            trigger: "blur"
          }, {
            validator: _validate.validateEMail,
            trigger: "blur"
          }]
          // belongSchool: [
          //   { required: true, message: "请输入所属学校", trigger: "blur" },
          // ],
        },
        labelWidth: "120px",
        inline: false,
        labelPosition: "right",
        size: "small",
        formItem: [{
          type: "input",
          label: "专家姓名：",
          isDisabled: false,
          placeholder: "请输入专家姓名",
          prop: "userName",
          value: "",
          span: 12
        }, {
          type: "input",
          label: "身份证号：",
          prop: "IDCode",
          value: "",
          placeholder: "请输入身份证号",
          span: 12
        }, {
          type: "input",
          label: "登录账号：",
          prop: "loginID",
          placeholder: "请输入登录账号",
          value: "",
          span: 12
        }, {
          type: "input",
          label: "手机号：",
          placeholder: "请输入手机号",
          prop: "tel",
          value: "",
          span: 12
        }, {
          type: "input",
          label: "邮箱：",
          placeholder: "请输入邮箱地址",
          prop: "email",
          value: "",
          span: 12
        }, {
          span: 12,
          type: "select",
          label: "所属学校：",
          isDisabled: false,
          multiple: false,
          placeholder: "请输入所属学校",
          prop: "belongSchool",
          value: [],
          options: [{
            name: "JavaScript",
            value: "JavaScript",
            isDisabled: true
          }, {
            name: "Java",
            value: "Java",
            isDisabled: false
          }]
        }]
      }
    };
  },
  methods: {}
};